import { Badge, Group } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useBadgeVariant } from "@hooks/useBadgeVariant";
import { HARDWARE_FAMILY_NAMES, type HeadsetRelease } from "types/headsetReleaseTypes";
import { familiesWithoutApk } from "./releaseFormat";

interface HardwareChipsProps {
  release: Pick<HeadsetRelease, "hardware" | "apks">;
}

export function HardwareChips({ release }: HardwareChipsProps) {
  const { t } = useTranslation();
  const badgeVariant = useBadgeVariant();
  const missing = familiesWithoutApk(release);
  return (
    <Group gap={6}>
      {release.hardware.map((family) =>
        missing.includes(family) ? (
          <Badge
            key={family}
            variant="outline"
            color="gray"
            tt="none"
            style={{ borderStyle: "dashed" }}
          >
            {t("headsetReleases.noApkFor", { family: HARDWARE_FAMILY_NAMES[family] })}
          </Badge>
        ) : (
          <Badge key={family} color="blue" variant={badgeVariant} tt="none">
            {HARDWARE_FAMILY_NAMES[family]}
          </Badge>
        ),
      )}
    </Group>
  );
}
